import Lazy from './Lazy';
import PureBaseComponent from './PureBaseComponent';

interface Props {
  alt: string;
  backgroundImage?: boolean;
  className: string;
  backgroundColor?: string;
  preload?: boolean;
  src?: string;
}

export default class LazyImage extends PureBaseComponent<Props> {
  static defaultProps: Partial<Props> = {
    alt: 'image',
    preload: false,
    src: '',
  };

  render() {
    const { alt, className, preload, src, backgroundColor } = this.props;

    const defaultImageStyle = {
      backgroundColor,
    };
    if (this.props.backgroundImage) {
      const imageStyle = {
        backgroundColor,
        backgroundImage: `url(${src})`,
      };

      return (
        <Lazy
          preload={preload}
          orElse={<div className={className} style={defaultImageStyle} title={alt} />}
        >
          <div className={className} style={imageStyle} title={alt} />
        </Lazy>
      );
    }

    return (
      <Lazy
        preload={preload}
        orElse={<div title={alt} className={className} style={defaultImageStyle} />}
      >
        <img className={className} style={defaultImageStyle} src={src} alt={alt} />
      </Lazy>
    );
  }
}
